/**
 * Scrolling Image Fader
 * Hijack the scrolling when the block fills the screen.
 * Cycle 1-4 lines of text wile zooming an image.
 *
 * @author Brian McGill <github.com/bmcgill>
 */

(function ($) {
  'use strict';

  const $scrollBox = $('.scrolling-image-fader'),
    $scrollBoxInner = $scrollBox.find('.wrapper');

  let $scrollBoxImages,
    $scrollBoxSubheadings,
    $scrollBoxHeight,
    $scrollBoxDots,
    $subheadingCount = 1,
    $currIndex = 0,
    $triggerPoint,
    $startPos,
    $endPos;

  Drupal.behaviors.initializeScrollingImageFader = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    $subheadingCount = $scrollBox.find('.copy .subheadings p').length;
    if ($subheadingCount <= 1) return false;

    // Adjust styling when there are multiple subheadings.
    $scrollBoxInner.addClass('sticky');

    // Set an artificial scroll height.
    // Increase the multiplier to increase the scroll distance.
    $scrollBox.height($scrollBox.height() * $subheadingCount * 1.5);
    // Add a class to let other scripts know that we're done changing the document height.
    $scrollBox.addClass('loaded');

    // Divide by the number of items to determine breakpoints animation transitions.
    $triggerPoint = Math.floor(100 / $subheadingCount);

    // Determine limits of when the window is fully visible on screen.
    $scrollBoxHeight = $scrollBox.height() - $scrollBoxInner.height();
    $startPos = $scrollBox.offset().top - $('header').height();
    $endPos = $startPos + $scrollBoxHeight;

    $scrollBoxImages = $scrollBox.find('.right img');
    $scrollBoxSubheadings = $scrollBox.find('.left .subheadings p');
    $scrollBoxDots = $scrollBox.find('.left .dots ul li');

    document.onscroll = function () {
      checkScrollPosition();
    };
  }

  function checkScrollPosition() {
    if (window.scrollY >= $startPos && window.scrollY <= $endPos) {
      // Calculate the percentage that the div has been scrolled.
      let $distanceScrolled = window.scrollY - $startPos;
      let $percentageScrolled = Math.round(
        $distanceScrolled / ($scrollBoxHeight / 100)
      );

      // Calculate the image index based on the scroll percentage and the number of images.
      let $nextIndex = Math.floor($percentageScrolled / $triggerPoint);
      if ($nextIndex != $currIndex && $nextIndex < $subheadingCount) {
        // Select image.
        $scrollBoxImages.eq($currIndex).removeClass('is-active');
        $scrollBoxImages.eq($nextIndex).addClass('is-active');

        // Switch text.
        $scrollBoxSubheadings.eq($currIndex).removeClass('is-active');
        $scrollBoxSubheadings.eq($nextIndex).addClass('is-active');

        // Switch dots
        $scrollBoxDots.eq($currIndex).removeClass('is-active');
        $scrollBoxDots.eq($nextIndex).addClass('is-active');

        $currIndex = $nextIndex;
      }
    }
  }
})(jQuery);
